import React from 'react';
import styled from 'styled-components';
import { useMediaQuery } from 'react-responsive'
import Fade from 'react-reveal/Fade';

const Container = styled.div`
  margin-top: 80px;
  position: relative;
  width: 100%;
  & > div {
    padding: 0 20px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
    & > img {
      width: 100%;
    }
    @media (max-width: 670px) {
      padding: 0;
    };
  }
  & > div:nth-child(1) {
    position: relative;
  }
`;

const Diagram = ({ style, img1, img2, img3, tImg1, tImg2, tImg3, mImg1, mImg2, mImg3, mobile, teblet, tebletMaxWidth, mobailMaxWidth }) => {
  const isDesktop = useMediaQuery({ minWidth: teblet })
  const isTeblet = useMediaQuery({ maxWidth: teblet, minWidth: mobile ? mobile : 0 })
  const isMobile = useMediaQuery({ maxWidth: mobile ? mobile : 0 })

  return (
    <Container style={style}>
      <div>
        <Fade>
          {
            isDesktop ?
              <img alt='' src={img1} />
              :
              (
                isTeblet ?
                  <img style={{ maxWidth: tebletMaxWidth }} alt='' src={tImg1} />
                  :
                  <img style={{ maxWidth: mobailMaxWidth }} alt='' src={mImg1} />
              )
          }
        </Fade>
      </div>
      <div>
        <Fade delay={1000}>
          {
            isDesktop ?
              <img alt='' src={img2} />
              :
              (
                isTeblet ?
                  <img style={{ maxWidth: tebletMaxWidth }} alt='' src={tImg2} />
                  :
                  <img style={{ maxWidth: mobailMaxWidth }} alt='' src={mImg2} />
              )
          }
        </Fade>
      </div>
      <div>
        <Fade delay={2000}>
          {
            isDesktop ?
              <img alt='' src={img3} />
              :
              (
                isTeblet ?
                  <img style={{ maxWidth: tebletMaxWidth }} alt='' src={tImg3} />
                  :
                  <img style={{ maxWidth: mobailMaxWidth }} alt='' src={mImg3} />
              )
          }
        </Fade>
      </div>
    </Container>
  )
}

export default Diagram;